// src/views/Procesos/ProaniOut/ListarLineasNoExportadasAlSap.jsx

import React, { useEffect, useState } from "react";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import ListFooter from "../../../components/listing/ListFooter";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson, apiFetch } from "../../../utils/http";

const PAGE_SIZE = 30;

export default function ListarLineasNoExportadasAlSap({
  onClose = () => {},
}) {
  // =========================
  // ESTADO
  // =========================
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0); // 0-based backend
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // =========================
  // ESC PARA CERRAR
  // =========================
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);

  // =========================
  // FETCH DATA
  // =========================
  const fetchData = async (pageToLoad = 0) => {
    setLoading(true);
    setError("");

    try {
      const url = apiRoutes.proaniOut.listUrl({
        page: pageToLoad,
        size: PAGE_SIZE,
        codigoProcesado: "NO", // legacy fijo
      });

      const data = await appFetchJson(url);

      setItems(data.items || []);
      setTotal(data.totalElements || 0);
      setPage(pageToLoad);
    } catch (e) {
      console.error(e);
      setItems([]);
      setTotal(0);
      setError("Error al cargar líneas no exportadas al SAP");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // =========================
  // EXPORTAR EXCEL (CON TOKEN)
  // =========================
  const exportarExcel = async () => {
    setError("");

    try {
      const url = apiRoutes.proaniOut.exportExcelUrl({
        codigoProcesado: "NO",
      });

      const res = await apiFetch(url, { method: "GET" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const blob = await res.blob();
      const objUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = objUrl;
      a.download = "lineas_no_exportadas_sap.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(objUrl);
    } catch (e) {
      console.error(e);
      setError("No se pudo exportar a Excel");
    }
  };

  // =========================
  // RENDER
  // =========================
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-panel-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* =========================
            HEADER
        ========================= */}
        <div className="modal-header relative bg-gray-50">
            {/* BOTÓN CERRAR */}
            <button
                onClick={onClose}
                className="absolute right-4 top-4 text-gray-500 hover:text-gray-800 text-xl font-bold"
                aria-label="Cerrar"
            >
                ×
            </button>

            <h2 className="section-title text-center">
                Líneas no exportadas al SAP
            </h2>
            </div>


        {/* =========================
            BODY (FONDO GRIS FLPA)
        ========================= */}
        <div className="modal-body bg-gray-50">
          <div className="border rounded-lg bg-white">
            <div className="px-6 py-4 space-y-4">

              {/* ACCIONES */}
              <div className="flex justify-end">
                <button
                  className="btn btn-primary"
                  onClick={exportarExcel}
                >
                  Exportar a Excel
                </button>
              </div>

              {/* ERROR */}
              {error && (
                <div className="alert alert-danger">{error}</div>
              )}

              {/* TABLA CON SCROLL */}
              <div
                className="overflow-y-auto border rounded bg-white"
                style={{ maxHeight: "55vh" }}
              >
                <table className="table-card table-sm w-full">
                  <thead className="table-head sticky top-0 z-10">
                    <tr>
                      <th className="cell">Línea</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="cell text-center">
                          Cargando…
                        </td>
                      </tr>
                    ) : items.length === 0 ? (
                      <tr>
                        <td className="cell text-center">
                          No hay registros
                        </td>
                      </tr>
                    ) : (
                      items.map((it, i) => (
                        <tr
                          key={it.id ?? i}
                          className={i % 2 === 0 ? "row-alt" : ""}
                        >
                          <td className="cell break-all">
                            {it.textoLinea ?? "—"}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

        {/* =========================
            FOOTER (ESTÁNDAR FLPA)
        ========================= */}
        <div className="modal-footer bg-gray-50">
          <div className="w-full space-y-3">
            <ListFooter
              page={page + 1}          // UI 1-based
              pageSize={PAGE_SIZE}
              total={total}
              onPageChange={(p) => fetchData(p - 1)}
            />

          </div>
        </div>
      </div>
    </div>
  );
}
